<template>
    <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Modèle')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                @onInit="onInit"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                @onSaveSuccess="onSaveSuccess"
                :ignoreRouteParamId="true"
                getRoot="/form-template"
                saveRoot="/form-template/create-from-form"
                :formStructure="dataFormStructures.form">
            <slot slot="beforeFormButtons">
                <slot name="formButtons">
                </slot>
            </slot>
        </DynamicForm>
    </b-modal>
</template>

<script>
    import DynamicForm from './DynamicForm'
    export default {
        name: 'ModalFormTemplate',
        components: {
            DynamicForm
        },
        props: {
        },
        computed: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataTitle: '',
                datBinderId: 0,
                dataBinderIndexId: 0,
                dataBinderFormId: 0,
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            open(binderId, binderIndexId, binderFormId) {
                this.dataShow = true
                this.dataBinderId = binderId
                this.dataBinderIndexId = binderIndexId
                this.dataBinderFormId = binderFormId
            },
            onInit() {
                this.$refs.dynamicForm.$refs.request.addArg('binderId', this.dataBinderId)
                this.$refs.dynamicForm.$refs.request.addArg('binderIndexId', this.dataBinderIndexId)
                this.$refs.dynamicForm.$refs.request.addArg('binderFormId', this.dataBinderFormId)
            },
            onRequestSuccess(data, method) {
            },
            onInitSuccess(data) {
            },
            onSaveSuccess(data) {
                this.dataShow = false
            }
        }
    }
</script>
